import {
  FUNDS_FETCH_FAILURE,
  FUNDS_FETCH_REQUEST,
  FUNDS_FETCH_SUCCESS,
} from './FundSuggestor.constants';

export default (state, action) => {
  switch (action.type) {
    case FUNDS_FETCH_REQUEST:
      return { ...state, error: null, isRequest: true };
    case FUNDS_FETCH_SUCCESS:
      return { ...state, funds: action.data, isFetched: true, isRequest: false };
    case FUNDS_FETCH_FAILURE:
      return { ...state, error: action.error, isRequest: false };
    default:
      return state;
  }
};
